import * as Rox from "rox-browser";

export const reconcile = {
  maxLimitWithDiscount: new Rox.Flag(),
  v2: new Rox.Flag(),
  ux__message_improvements: new Rox.Flag(),
};
